import { render, staticRenderFns } from "./AttendanceClockRecord.vue?vue&type=template&id=88922714&"
import script from "./AttendanceClockRecord.vue?vue&type=script&lang=js&"
export * from "./AttendanceClockRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports